
<div id="content" class="main-content">
    <div class="container">
        <div class="col-12 pl-0">
            <div class="crumbs breadcrumbs-style-2">
                <ul class="breadcrumb">
                    <li class="mt-3"><a href="dashboard" routerLink="/dashboard"><i class="flaticon-home-fill"></i></a>
                    </li>
                    <li class="active mt-3 current_arian"><a href="javascript:void(0);" class="current_arian">Statistiques de {{connectedCompany}}</a></li>
                </ul>
            </div>
        </div>
        <div class="page-header">
            <div class="page-title col-lg-8 col-md-8 col-sm-12 col-xs-12 justify-content-between">
                <h2 style="color:black"><b>Statistiques des clients</b> - {{currentYear}}</h2>
            </div>
        </div>
        <div class="row layout-spacing mb-3" >
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 layout-spacing">
                <div class="statbox widget box box-shadow">
                    <div class="widget-header">
                        <div class="row">
                            <div class="col-xl-12 col-md-12 col-sm-12 col-12">
                                <h4 class="pb-1">Présence géographique des clients</h4>
                                <p class="ml-3">(Selon le réferentiel)</p>
                            </div>                           
                        </div>
                    </div>
                    <div class="widget-content widget-content-area br-4 h-100">
                        <div class="visitor-engagement">
                            <div class="visitor-engagement-body">
                                <!-- <p *ngIf="noIndicatorsSectorsExist">Aucun donnée à afficher</p> -->
                                <div class="row">
                                    <div *ngIf="loadingCustomersMaps" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 15%;
                                        margin-bottom: 15%;">
                                    </div>
                                    <div class="col-md-12 col-md-12 col-sm-12 col-12 container-presence-maps" *ngIf="!loadingCustomersMaps">
                                        <div id="maps_customers" ></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
        <div class="row layout-spacing" >
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 layout-spacing">
                <div class="statbox widget box box-shadow">
                    <div class="widget-header">
                        <div class="row">
                            <div class="col-xl-12 col-md-12 col-sm-12 col-12">
                                <h4>Nombre des clients par secteur</h4>
                            </div>                           
                        </div>
                    </div>
                    <div class="widget-content widget-content-area br-4 h-100">
                        <div class="visitor-engagement">
                            <div class="visitor-engagement-body">
                                <p *ngIf="noIndicatorsSectorsExist">Aucun donnée à afficher</p>
                                <div class="row" *ngIf="!noIndicatorsSectorsExist">
                                    <div *ngIf="loadingSectorsIndicators" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 15%;
                                        margin-bottom: 15%;">
                                    </div>
                                    <div class="col-md-12 col-md-12 col-sm-12 col-12">
                                        <div id="myChart_sectors" ></div>
                                    </div>
                                </div>
                                <p style="color: #513ba1;" class="col-sm-12 mt-4" *ngIf="withoutCustomers.length>0 && !noIndicatorsSectorsExist">
                                    <img width="20" src="../../../assets/img/suivitim_img/no_sectors.gif">
                                    <b> Les secteurs qui n'ont pas de clients : </b><br>
                                    <span class="row col-sm-12 col-lg-12 sector_without_customers" style="overflow-y: scroll; max-height: 100px;" >
                                        <p class="col-sm-6 col-lg-6 " *ngFor="let sect of withoutCustomers">● {{sect.sector}}</p>
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


        